export default "__VITE_ASSET__Dva2Wfq1__"